var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('basic-heading',{attrs:{"title":"Batch Result Manager"}}),_c('batch-result-manager-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }